import { createSlice } from "@reduxjs/toolkit";

// Phases: "initiated" | "power_off" | "device_offline" | "complete" | null
const powerCycleSlice = createSlice({
  name: "powerCycle",
  initialState: {
    // { [serialNumber]: { phase, startedAt } }
    devices: {},
  },
  reducers: {
    startCycle(state, action) {
      const sn = action.payload;
      state.devices[sn] = { phase: "initiated", startedAt: Date.now() };
    },
    setPhase(state, action) {
      const { sn, phase } = action.payload;
      if (state.devices[sn]) {
        state.devices[sn].phase = phase;
      }
    },
    clearCycle(state, action) {
      const sn = action.payload;
      delete state.devices[sn];
    },
  },
});

export const { startCycle, setPhase, clearCycle } = powerCycleSlice.actions;

export const selectCyclePhase = (sn) => (state) =>
  state.powerCycle.devices[sn]?.phase || null;

export default powerCycleSlice.reducer;
